export const setLanguage = language => ({
  type: 'SET_LANGUAGE',
  language: language
})
